import { LinearProgress, LinearProgressProps, Typography, linearProgressClasses, styled } from "@mui/material";

interface IPropsProgress {
    height?: number;
    width?: number;
    fullWidth?: boolean;
    backgroundColor?: string;
    border?: "solid" | "none";
    helperText?: React.ReactNode;
}

type IProps = Omit<LinearProgressProps & IPropsProgress, "variant" | "sx">;

const BorderLinearProgress = styled(
    LinearProgress,
    { shouldForwardProp: (propName: string) => !["height", "width", "fullWidth", "backgroundColor", "border"].includes(propName) }
)<{ height?: number; width?: number; backgroundColor?: string; border?: "solid" | "none", fullWidth?: boolean; }>
    (({
        theme,
        height,
        width,
        backgroundColor,
        border,
        fullWidth
    }) => ({
        height: height ?? 12,
        width: fullWidth ? "100%" : width ?? 200,
        [`&.${linearProgressClasses.root}`]: {
            backgroundColor: backgroundColor ?? theme.palette.common.white,
            borderColor: theme.palette.muted.light,
            borderWidth: border == "none" ? 0 : 1,
            borderStyle: border == "none" ? "none" : "solid"
        }
    }));

export const MprcProgress: React.FC<IProps> = (props) => {
    const { helperText, height, width, backgroundColor, border = "solid", ...rest } = props;

    return (
        <>
            <BorderLinearProgress
                variant="determinate"
                {...rest}
                height={height}
                width={width}
                backgroundColor={backgroundColor}
                border={border}
                title={`${rest.value}%`}
            />
            {helperText &&
                <Typography variant="caption" component="p" sx={{ lineHeight: 1.2, mt: 0.5 }}>
                    {helperText}
                </Typography>
            }
        </>
    );
};
